import { useContext } from 'react';
import AppContext from '@/contexts/AppContext';
import { t } from '@/locales/strings';

export function useStrings() {
  const { lang } = useContext(AppContext);
  return (key) => t(key, lang);
}
